import React, { Component } from "react";
import { Label, FormGroup, Modal } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import baseURL from "../../config";

class AddParent extends Component {
  constructor(props) {
    super(props);
    this.onCancel = this.onCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    const newParent = {
      name: "",
      surname: "",
      email: "",
      password: "",
      passwordConfirm: "",
    };

    const messageError = {
      messageAlert: "",
    };

    this.state = { newParent, messageError };
  }

  onCancel() {
    const { newParent } = this.state;
    newParent.name = "";
    newParent.surname = "";
    newParent.email = "";
    newParent.password = "";
    this.props.onCancel();
  }

  onSubmit(e) {
    const { newParent } = this.state;
    // if (newParent.password !== newParent.confirmPassword) {
    //   alert("Confirm password should be the same with password!");
    // }

    e.preventDefault();
    fetch(`${baseURL}/api/v1/users/signup`, {
      method: "POST",
      body: JSON.stringify(newParent),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }).then((response) => {
      response.json().then((data) => {
        this.setState(newParent);
        this.onCancel();
        window.location.reload()
      });
    });
  }

  handleChange(e) {
    const { name, value } = e.target;
    const { newParent } = this.state;
    newParent[name] = value;
    this.setState({ newParent });
  }

  render() {
    const { newParent } = this.state;
    return (
      <Modal isOpen={this.props.isNewParentModalOpen} toggle={this.onCancel}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Добави стопанин</h5>
          <button
            type="button"
            onClick={this.onCancel}
            className="close"
            data-dismiss="modal"
            aria-label="Затвори"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <AvForm className="needs-validation">
            <FormGroup>
              <Label htmlFor="validationCustom01">Име </Label>
              <AvField
                name="name"
                placeholder="Име"
                type="text"
                errorMessage="Моля, въведете име"
                className="form-control"
                onChange={this.handleChange}
                value={newParent.name}
                validate={{ required: { value: true } }}
                id="validationCustom01"
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="validationCustom02">Фамилия</Label>
              <AvField
                name="surname"
                placeholder="Фамилия"
                type="text"
                errorMessage="Моля, въведете фамилия"
                className="form-control"
                onChange={this.handleChange}
                value={newParent.surname}
                validate={{ required: { value: true } }}
                id="validationCustom02"
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="validationCustom02">Имейл</Label>
              <AvField
                name="email"
                placeholder="Имейл"
                type="email"
                errorMessage="Моля, въведете имейл"
                className="form-control"
                onChange={this.handleChange}
                value={newParent.email}
                validate={{ required: { value: true } }}
                id="validationCustom02"
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="validationCustom02">Парола</Label>
              <AvField
                name="password"
                placeholder="Парола"
                type="password"
                errorMessage="Моля, въведете парола"
                className="form-control"
                onChange={this.handleChange}
                value={newParent.password}
                validate={{ required: { value: true } }}
                id="validationCustom02"
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="validationCustom02">Потвърди парола</Label>
              <AvField
                name="passwordConfirm"
                placeholder="Потвърди парола"
                type="password"
                errorMessage="Моля, потвърдете паролата коректно"
                className="form-control"
                onChange={this.handleChange}
                value={newParent.passwordConfirm}
                validate={{ required: { value: true } }}
                id="validationCustom02"
              />
            </FormGroup>
          </AvForm>
        </div>

        {this.props.isLoading && (
          <div className="modal-footer">
            <div className="spinner-border text-success m-1" role="status">
              <span className="sr-only">Зареждане…</span>
            </div>
          </div>
        )}

        {!this.props.isLoading && (
          <div className="modal-footer">
            <button
              type="button"
              onClick={this.onCancel}
              className="btn btn-secondary waves-effect"
              data-dismiss="modal"
            >
              Отказ
            </button>
            <button
              type="button"
              onClick={this.onSubmit}
              className="btn btn-success waves-effect waves-light"
            >
              Добави
            </button>
          </div>
        )}
      </Modal>
    );
  }
}

export default AddParent;
